/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {
  channel_type_style,
  channel_bind_status_enum,
  status_enum,
  MemberSt,
  channel_type_enum,
} from 'hiya-common/src/reducers/commonTypes'
import {noSelPayPaths} from './constant'

// 待确认（黄色）已确认（绿色）已拒绝（红色）已失效（灰色）
export enum InviteStatus {
  Confirm = 0,
  Confirmed = 1,
  Fail = 2,
  Reject = 3,
}

export enum InviteBDStatus {
  Confirm = -1,
  Confirmed = 1,
  Fail = -3, // 失效
  Reject = -2,
}

// 1 公会 2 主播 3 直播
export enum HomeTabs {
  Guild = 1,
  Anchor = 2,
  Live = 3,
}

// 1公会长 2主播 3普通人 4管理员
export enum RoleStatus {
  Guild = 1,
  Anchor = 2,
  Live = 3,
  Manager = 4,
}

// 获取直播周期
export const getLiveCenterPeriod = createAsyncThunk(
  'AnchorCenter/getLiveCenterPeriod',
  async (p: any, store: any) => {
    const resp = await http.post('/live/settle/settle_cfg', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 直播信息Tab http://wiki.xunlei.cn/pages/viewpage.action?pageId=100420016
export const getLiveInfo = createAsyncThunk(
  'AnchorCenter/getLiveInfo',
  async (p: any, store: any) => {
    const resp = await http.post('/live/settle/live_info_tab', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 公会信息tab http://wiki.xunlei.cn/pages/viewpage.action?pageId=100419207
export const getUnionInfoTab = createAsyncThunk(
  'AnchorCenter/getUnionInfoTab',
  async (p: any, store: any) => {
    const resp = await http.post('/live/settle/union_info_tab', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 获取主播信息 tab http://wiki.xunlei.cn/pages/viewpage.action?pageId=100420001
export const getAnchorInfoTab = createAsyncThunk(
  'AnchorCenter/getAnchorInfoTab',
  async (p: any, store: any) => {
    const resp = await http.post('/live/settle/anchor_info_tab', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 获取主播列表或管理员列表 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100419821
export const getAnchorManageList = createAsyncThunk(
  'AnchorCenter/getAnchorManageList',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/anchor_list_leader', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 删除主播
export const deleteUnionAnchor = createAsyncThunk(
  'UnionData/deleteUnionAnchor',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/anchor_delete_from_leader',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

// 取消管理员身份
export const cancelAdminAnchorByLeader = createAsyncThunk(
  'UnionData/cancelAdminAnchorByLeader',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/cancel_manager_from_leader', {
      ...store.getState().env.deviceinfo,
      leader_mid: store.getState().env.deviceinfo.h_m,
      ...p,
    })
    return resp.data
  }
)

// 设置管理员身份
export const setAdminAnchorByLeader = createAsyncThunk(
  'UnionData/setAdminAnchorByLeader',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/add_manager_from_leader', {
      ...store.getState().env.deviceinfo,
      leader_mid: store.getState().env.deviceinfo.h_m,
      ...p,
    })
    return resp.data
  }
)

// 邀请主播
export const inviteUnionAnchor = createAsyncThunk(
  'UnionData/inviteUnionAnchor',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/anchor_add_from_leader', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 管理员邀请主播
export const inviteUser = createAsyncThunk(
  'UnionData/inviteUser',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/anchor_add_from_manager', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 支付入口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92448321
export const getPayEnter = createAsyncThunk(
  'AnchorCenter/getPayEnter',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/settle/pay_enter',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

// 收款渠道 ok true 弹  是否弹出确认默认支付弹窗 http://wiki.xunlei.cn/pages/viewpage.action?pageId=122806606
export const check_default_pay_infom = createAsyncThunk(
  'AnchorCenter/check_default_pay_infom',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/check_default_pay_inform', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

// 确认弹窗 http://wiki.xunlei.cn/pages/viewpage.action?pageId=122806606
export const set_default_pay_inform = createAsyncThunk(
  'AnchorCenter/set_default_pay_inform',
  async (p: {id: string}, store: any) => {
    const resp = await http.post(
      '/live/union/set_default_pay_inform',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const getInvitationDetail = createAsyncThunk(
  'AnchorCenter/getInvitationDetail',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/get_union_detail',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)
// http://wiki.xunlei.cn/pages/viewpage.action?pageId=120401941
export const vip_level_info = createAsyncThunk(
  'AnchorCenter/live/vip/level_info',
  async (p, store: any) => {
    const resp = await http.post('/live/vip/level_info', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
// http://wiki.xunlei.cn/pages/viewpage.action?pageId=90610956
export const confirmInvitation = createAsyncThunk(
  'AnchorCenter/confirmInvitation',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/anchor_confirm_invite',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

// 邀请主播 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100429529
export const inviteBDAnchor = createAsyncThunk(
  'AnchorCenter/inviteBDAnchor',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/get_common_invite_by_ids',
      {
        ...store.getState().env.deviceinfo,
        ...p,
        kind: 2,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

// 邀请主播确认 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100429524
export const confirmInviteBDAnchor = createAsyncThunk(
  'AnchorCenter/confirmInviteBDAnchor',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/common_confirm_invite',
      {
        ...store.getState().env.deviceinfo,
        ...p,
        kind: 2,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

// 实时数据 总览  http://wiki.xunlei.cn/pages/viewpage.action?pageId=117025048
export const live_overview = createAsyncThunk(
  'AnchorCenter/live_overview',
  async (
    p: {
      t_range: string
    },
    store: any
  ) => {
    const resp = await http.post(
      '/live/settle/live_overview',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 获取公会长信息  http://wiki.xunlei.cn/pages/viewpage.action?pageId=100418155
// 用于判断当前的是公会长还是主播
export const union_owner_info_by_mid = createAsyncThunk(
  'AnchorCenter/live/settle/union_owner_info_by_mid',
  async (
    p: {
      h_m: number
    },
    store: any
  ) => {
    const resp = await http.post(
      '/live/settle/union_owner_info_by_mid',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 主播等级首页数据  http://wiki.xunlei.cn/pages/viewpage.action?pageId=120390669
export const level_home_page = createAsyncThunk(
  'AnchorCenter/live/union/home_page',
  async (p, store: any) => {
    const resp = await http.post(
      '/live/union/home_page',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 修改默认的支付方式 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92447654
export const update_default_pay = createAsyncThunk(
  'union_update_default_pay',
  async (
    arg: {
      channel_type: channel_type_enum
      id: string
      from?: any
    },
    store: any
  ) => {
    const resp = await http.post<HiyaRes<{err_msg: string}>>(
      '/live/settle/update_default_pay',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 根据mid获取支付绑定和认证信息列表 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92447647
export const pay_bind_list_by_mid = createAsyncThunk(
  'AnchorCenter_pay_bind_list_by_mid',
  async (
    arg: {
      channel_type?: any
      need_pass?: boolean
      version?: number
      need_trans_account?: boolean
    },
    store: any
  ) => {
    const {h_m: mid} = store.getState().env.deviceinfo
    const resp = await http.post('/live/settle/pay_bind_list_by_mid', {
      ...store.getState().env.deviceinfo,
      mid,
      ...arg,
    })
    return resp.data.data
  }
)

// 新公会长获取结算 http://wiki.xunlei.cn/pages/viewpage.action?pageId=138980656
export const get_live_settlement = createAsyncThunk(
  'settle/get_live_settlement',
  async (p: any, store: any) => {
    const resp = await http.post('/live/settle/live_settlement', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)
export interface Pair {
  cur: string
  next: string
}

export interface Period {
  value: string
  text: string
}

export interface AnchorCenterde_list {
  list?: Array<{
    ct: string
    money: number
  }>
  page_size?: number
  offset?: number
  more?: boolean
}

// 收入列表
export interface LiveList {
  mid: number
  ct: string
  times: number
  effect_times: number
  time: number // 直播秒数
  effect_time: number
  on_mic_income: number
  room_id?: number
  income?: number
  st?: string
  et?: string
  remain_time?: number
}

// 主播公会信息
export interface AnchorUnion {
  union_id: number
  name: string
  join_t: any
  // 目前所在的公会就没有退出时间
  quit_t?: any
  joined: Array<AnchorUnion>
  // 主播经历唯一表示id
  id: number
}

// 直播统计信息
export interface LiveInfo {
  is_reach_live_time: boolean // 是否达标
  is_current_period_join: boolean // 是否是当前周期加入的
  live_days: number // 直播有效天数
  enable_income: number // 可以获得的薪资
  diamond: number
  level: Pair
  exp: Pair // 经验
  day: Pair
  today_live_sec: Pair // 今天直播的时间 和需要达标的时间
  anchor_income: number // 预估总薪资
  exchange_income: number // 已兑换薪资
  pay_income: number // 预估发薪资
  settle_config_type: number // 枚举 0就是普通政策，1就是新主播扶持政策，在扶持周期内
}

export interface AnchorCenterLiveItem {
  // 自己的房间id
  room_id?: number
  anchor_union?: AnchorUnion
  live_info?: LiveInfo
  list?: Array<LiveList>
  page_size?: number
  offset?: number
  more?: boolean
}

export interface AnchorCenterUnionInfo {
  member?: any
  diamond?: number
  union?: {
    name: string
    union_id: number
    country: string
    ct: any
    anchor_cnt: number
    last_monday_female_ratio?: string
    this_monday_female_ratio?: string
    parking?: number // 1 打包
    country_flag: string
  }
  icon_list?: Array<{
    img: string
    name: string
    url: string
  }>
}

export interface AnchorCenterAnchorInfo {
  member?: any
  room?: {
    name: string
    room_id: number
    img: string
    level: Pair
    exp: Pair
    cnt: Pair
  }
  icon_list?: Array<{
    img: string
    name: string
    url: string
    sign_status: string
  }>
  diamond?: number
}

export interface AnchorCenterManageInfo {
  from?: number
  list?: Array<{
    avatar: string
    show_id: string
    mid: number
    name: string
    income: number
    effective_day: number
    gender: number // 1女 2男 0保密
    is_manager: boolean // true 是
    age?: number
    selected?: boolean
  }>
  sort?: number
  page_size?: number
  offset?: number
  more?: boolean
}
export enum default_pay_status {
  在窗口期且不用弹窗 = 0,
  不在窗口期 = 1,
  在窗口期且需要弹窗确认默认支付 = 2,
}
export interface AnchorCenterPayEnter {
  menu_list?: Array<{
    title: string
    link: string
    menu_type: number
    sign_status: string
    status_color: string
    bind_status?: channel_bind_status_enum
    status?: status_enum
    style?: channel_type_style
    channel_type: channel_type_enum
    channel_account?: string
    owner?: MemberSt // 针对公会长代收需要公会长信息
    is_default?: boolean
    id?: string
    noSel?: boolean // true为不可选中的渠道
  }>
  menu_title?: string
  default_channel?: channel_type_enum
  check_default_pay_infom?: {
    id?: string
    default_channel?: channel_type_enum
    status: default_pay_status
  }
}

export interface AnchorCenterInviteInfo {
  list?: Array<{
    id: string
    mid: number
    show_id: string
    union_id: number
    status: number // 0:默认，1:申请已同意, 2:申请已过期
    inviter_mid: number
    inviter_show_id: string
    ct: number
    ut: number
  }>
  page_size?: number
  offset?: number
  more?: boolean
}

export interface AnchorCenterListInfo {
  diamond?: number
  list?: Array<any>
  page_size?: number
  offset?: number
  more?: boolean
  total_diamond?: number
}

export interface AnchorCenterSettlementInfo {
  union_settlement?: any
  anchor_settlement?: Array<any>
  page_size?: number
  offset?: number
  more?: boolean
  sort?: number
}

export interface AnchorCenterGiftDetailList {
  on_mic_data?: AnchorCenterListInfo
  off_mic_data?: AnchorCenterListInfo
  im_data?: AnchorCenterListInfo
  post_data?: AnchorCenterListInfo
  other_data?: AnchorCenterListInfo
}
export const PageSize = 20
// http://wiki.xunlei.cn/pages/viewpage.action?pageId=113909020
export interface salary_overview_type {
  overview: {
    total_salary: number
    union_salary: number
    on_anchor_salary: number
    on_anchor_cnt: number
    off_anchor_salary: number
    off_anchor_cnt: number
  }
  base: {
    on_anchor_salary: number
    on_anchor_cnt: number // 有基础薪资的在会主播 人
    on_commission: number // 公会长分成：
    off_anchor_salary: number // 本周期退会主播基础薪资：
    off_anchor_cnt: number // 有基础薪资的退会主播 人
    off_commission: number // 公会长分成：
  }
  reward: {
    on_anchor_salary: number // 本周期在会主播个人奖惩总和：
    on_anchor_cnt: number // 有个人奖惩薪资的在会主播：
    off_anchor_salary: number // 本周期退会主播个人奖惩总和：
    off_anchor_cnt: number // 有个人奖惩薪资的退会主播：
    total_reward: number // 公会奖励总和：
    total_punish: number // 公会惩罚总和：
  }
  refund: {
    on_anchor_salary: number // 本周期在会主播因前周期退款/回款被影响薪资：
    on_anchor_cnt: number // 本周期在会主播被退款影响：
    on_commission: number // 公会长因此被影响：
    off_anchor_salary: number // 本周期退会主播因前周期退款/回款被影响薪资：
    off_anchor_cnt: number // 本周期退会主播被退款影响：
    off_commission: number // 公会长因此被影响：
    pre_off_anchor_salary: number // 前周期退会主播因前周期退款/回款被影响薪资：
    pre_off_anchor_cnt: number // 前周期退会主播被退款影响：
    pre_off_commission: number // 公会长因此被影响：
  }
}
export interface live_overview_type {
  overview?: {
    diamond: number // 钻石
    incr: number // 今日增长
    anchor_cnt: number // 总主播数量
    off_anchor_cnt: number // 退会主播数量
  }
  distribution?: {
    level: number // 等级
    on_cnt: number // 在会数量
    off_cnt: number // 退会数量
    total: number // 总数量
  }[]
  selAnchor?: {
    mid: number
    id: number
  }
}
export interface hall_of_fame_type {
  member: MemberSt // 基础信息
  sort: number // 排名 1月份最靠前
  month: number // 月份
  color: string // 颜色
  score: number // 分数
}
interface PairFloat {
  cur: number
  incr: number
}
const initialState: {
  live_tab_info?: AnchorCenterLiveItem
  period_list?: Array<Period>
  cur_period?: string
  de_list?: AnchorCenterde_list
  cashout_ids_list?: Array<Period>
  union_info?: AnchorCenterUnionInfo
  anchor_info?: AnchorCenterAnchorInfo
  anchor_info_list?: AnchorCenterManageInfo
  manage_info_list?: AnchorCenterManageInfo
  pay_enter?: AnchorCenterPayEnter
  invite_info_list?: AnchorCenterInviteInfo
  gift_info_list?: AnchorCenterListInfo
  refund_info_list?: AnchorCenterListInfo
  settlement_info_list?: AnchorCenterSettlementInfo
  gift_detail_list?: AnchorCenterGiftDetailList
  live_overview?: live_overview_type
  level_home_page?: {
    count_down?: number
    member?: MemberSt
    banners?: {
      id: number // banner id
      cover: string // banner图片
      link: string // banner跳转链接
      score: number // banner权重
    }[]
    anchor_info?: {
      union_id: number // 公会id
      days: number // 成为主播天数 （如果主播中途退出公会，则数据清零）
      new: 0 | 1 // 是否新主播 0:否 1:是
      level: number // 主播等级  0New 1Rising 2Super 3Silvier 4Golden 5Legend
      score: number // 当前分数
      stage_job_score: number // 等级任务进度
    }
    level_rewards?: {
      level: number // 主播等级 0New 1Rising 2Super 3Silvier 4Golden 5Legend
      min_score: number // 最低等级分数
      score: number // 主播等级分数
      rewards: {
        icon: string // icon
        desc: string // 描述
      }[]
    }[]
    stage_jobs?: {
      id: number // 阶段id
      need: number // 阶段需要值
      icon: string // 阶段任务ICON
      status: number // 0:未达到;1:目标达到;2:奖励已领取
      name: string // 阶段任务名称
    }[]
    jobs?: {
      id: number // 阶段id
      name: string
      status: number // 0:未达到;1:目标达到;2:奖励已领取
      jump_url: string // 跳转链接
      reward_cnt: number // 奖励钥匙数量
    }[]
  }
  union_owner_agent_overview?: {
    income?: PairFloat
    anchor?: PairFloat
  }
  others_collection_overview?: {
    income?: PairFloat
  }
  vip_level_info?: {
    has_limit: boolean
    limit_level: number
    vip_level: number
  }
  // 获取公会长信息
  union_owner_info?: {
    member: MemberSt
    union: {
      mid: number
      create_time: string
      is_cash_out: number
      union_id: number
      union_name: string
      union_mid: number
      union_area_code: number
    }
  }
  pay_bind_list?: {
    channel_type: channel_type_enum
    channel_account: string
    default_channel_type: channel_type_enum
  }[]
  cycleRange: string
} = {
  live_tab_info: {},
  period_list: [],
  de_list: {},
  union_info: {},
  anchor_info: {},
  anchor_info_list: {},
  manage_info_list: {},
  pay_enter: {},
  invite_info_list: {},
  gift_info_list: {},
  refund_info_list: {},
  settlement_info_list: {},
  gift_detail_list: {
    on_mic_data: {},
    off_mic_data: {},
    im_data: {},
    post_data: {},
    other_data: {},
  },
  level_home_page: {},
  union_owner_agent_overview: {},
  others_collection_overview: {},
  cycleRange: '',
}

export const AnchorCenterSystemSlice = createSlice({
  name: 'AnchorCenterSystem',
  initialState,
  reducers: {
    selLiveViewAnchor: (state, action) => {
      Object.assign(state, {
        live_overview: {
          ...state.live_overview,
          selAnchor: {...action.payload},
        },
      })
    },
    clearUnionAnchorList: (state) => {
      Object.assign(state.anchor_info_list, {
        list: [],
        offset: 0,
      })
    },
    setUnionAnchorList: (state, action) => {
      const {list} = action.payload
      Object.assign(state.anchor_info_list, {
        list,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getLiveInfo.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      if (data?.offset > 20) {
        Object.assign(state.live_tab_info, {
          ...data,
          list: [...state.live_tab_info.list, ...data?.list],
        })
      } else {
        Object.assign(state.live_tab_info, data)
      }
    })
    builder.addCase(getLiveCenterPeriod.fulfilled, (state, action) => {
      const {
        data: {list},
      } = action.payload
      Object.assign(
        state.period_list,
        list.map((item) => {
          return {text: item, value: item}
        })
      )
    })
    builder.addCase(getUnionInfoTab.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state.union_info, data)
    })
    builder.addCase(getAnchorInfoTab.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state.anchor_info, data)
    })
    builder.addCase(getAnchorManageList.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      if (data?.from === 0) {
        // 主播列表
        if (data?.offset > 20) {
          Object.assign(state.anchor_info_list, {
            ...data,
            list: [...state.anchor_info_list.list, ...data?.list],
          })
        } else {
          Object.assign(state.anchor_info_list, data)
        }
      }
      if (data?.from === 1) {
        // 管理员列表
        if (data?.offset > 20) {
          Object.assign(state.manage_info_list, {
            ...data,
            list: [...state.manage_info_list.list, ...data?.list],
          })
        } else {
          Object.assign(state.manage_info_list, data)
        }
      }
    })
    builder.addCase(get_live_settlement.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      if (data?.offset > 20) {
        Object.assign(state.settlement_info_list, {
          ...data,
          list: state.settlement_info_list?.anchor_settlement
            ? [
                ...state.settlement_info_list?.anchor_settlement,
                ...data?.anchor_settlement,
              ]
            : [...data?.anchor_settlement],
        })
      } else {
        Object.assign(state.settlement_info_list, data)
      }
    })
    builder.addCase(live_overview.fulfilled, (state, action) => {
      Object.assign(state, {
        live_overview: {
          ...action.payload,
        },
      })
    })

    // 主播等级中心
    builder.addCase(level_home_page.fulfilled, (state, action) => {
      Object.assign(state.level_home_page, action.payload || {})
    })
    builder.addCase(vip_level_info.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, {vip_level_info: data})
    })
    builder.addCase(getPayEnter.fulfilled, (state, action) => {
      const {union_owner_info, pay_bind_list} = state
      const temp = []
      let default_channel = 0
      // const
      pay_bind_list.forEach((pay) => {
        // 将绑定的默认渠道放到第一个
        if (pay.default_channel_type === pay.channel_type) {
          temp.unshift(pay)
          default_channel = pay.default_channel_type
        } else {
          temp.push(pay)
        }
      })

      const {
        data: {menu_list = [], menu_title},
      } = action.payload
      // 已经绑定的渠道
      const binded_list = temp.map((bI) => ({
        id: bI.id,
        channel_account: bI.channel_account,
        ...menu_list?.find((m) => m.channel_type === bI.channel_type),
      }))
      // 可选渠道的顺序：通过的渠道，不能被选择的渠道，未审核的渠道
      Object.assign(state.pay_enter, {
        menu_list: [
          ...binded_list.filter(
            (bI) => !noSelPayPaths.some((noSel) => noSel === bI.channel_type)
          ),
          ...binded_list
            .filter((bI) =>
              noSelPayPaths.some((noSel) => noSel === bI.channel_type)
            )
            ?.map((item) => ({...item, noSel: true})),
          ...menu_list.filter(
            (m) => !binded_list.some((bI) => bI.channel_type === m.channel_type)
          ),
        ]?.map((menu) => ({
          ...menu,
          ...(menu.channel_type === channel_type_enum.公会长代收
            ? {
                owner: union_owner_info.member,
              }
            : {}),
        })),
        menu_title,
        default_channel,
      })
    })
    builder.addCase(check_default_pay_infom.fulfilled, (state, action) => {
      Object.assign(state.pay_enter, {check_default_pay_infom: action.payload})
    })
    builder.addCase(union_owner_info_by_mid.fulfilled, (state, action) => {
      Object.assign(state, {union_owner_info: action.payload})
    })
    builder.addCase(pay_bind_list_by_mid.fulfilled, (state, action) => {
      Object.assign(state, {
        pay_bind_list: action.payload?.list || [],
      })
    })
  },
})

export const AnchorCenterAction = AnchorCenterSystemSlice.actions
export default AnchorCenterSystemSlice.reducer
